<div>
  <div class="d-flex align-items-center justify-content-center mt-3">
    <span class="welcome-text"> Welcome to</span>
    <img
      class="d-flex align-items-center px-2"
      src="assets/icons/svg/HeartLogo.svg"
      alt="Webiste logo"
    />
    <span class="impact-text d-flex align-items-center"> EY Impact</span>
  </div>
  <div class="mt-3 px-5 flow-content">
    To help you get the most out of the app, please turn on the User Guide. It
    will walk you through key features step-by-step. Would you like to enable it
    now?
  </div>
  <div class="footer-buttons gap-2">
    <button class="skip-button" (click)="skip()">Skip</button>
    <button class="enable-button" (click)="startTour()">Enable</button>
  </div>
</div>
